import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import PricingCardFeature from './PricingCardFeature';
import clsx from 'clsx';
import color from 'color';

const styles = theme => ({
  priceBox: {
    width: 340,
    padding: 30,
  },
  activePriceBox: {
    backgroundColor: color(theme.palette.primary.main).lighten(1).string(),
    border: `3px solid ${theme.palette.primary.main}`,
  },
  pricePlan: {
    fontSize: 20,
  },
  priceHeader: {
    textAlign: 'center',
  },
  price: {
    marginTop: 40,
    fontSize: 36,
  },
  customPriceFiller: {
    marginTop: '13px',
    display: 'block',
    fontSize: '50px',
  },
  priceSmall: {
    fontSize: 12,
    color: '#151f26',
    fontWeight: 'normal',
    marginTop: 14,
    display: 'block',
  },
  priceAdditional: {
    fontSize: 16,
    color: '#72848e',
    marginTop: 20,
  },
  ctaButton: {
    marginTop: 20,
    width: '100%',
    maxWidth: 222,
  },
  currentPlan: {
    fontSize: '22px',
    marginTop: '40px',
    marginBottom: '58px',
  },
  planDescription: {
    marginTop: 40,
    color: '#72848e',
  },
  activePlanDescription: {
    color: '#35383a',
  },
  divider: {
    marginTop: 20,
    marginBottom: 20,
    backgroundColor: '#72848e',
    height: 1,
    width: '100%',
    opacity: 0.2,
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },
  },
});

const customPlanButtonHref =
  "mailto:support@ownerfy.com?subject=Let's%20chat%20about%20a%20custom%20plan&body=I'd%20love%20to%20talk%20about%20information%20to%20set%20up%20a%20custom%20plan%20for%20Ownerfy%20registration%20codes.%0A%0AName%3A%20YOUR_NAME%0ACompany%3A%20COMPANY_NAME%0APhone%20Number%3A%20PHONE_NUMBER%0ANumber%20of%20total%20products%20to%20be%20registered%3A%20NUMBER_OF_PRODUCTS_TO_REGISTER%0ANumber%20of%20monthly%20registrations%20expected%3A%20NUMBER_OF_MONTHLY_REGISTRATIONS";

function PricingCard({
  pricePlan,
  price,
  planDescription,
  features,
  classes,
  className,
  isCustom,
  planId,
  isActive,
  activePlanId,
}) {
  function buildUrl() {
    let url = `/checkout?planId=${planId}`;
    console.log('activePlanId', activePlanId);
    if (activePlanId) {
      url += `&previousPlanId=${activePlanId}`;
    }
    return url;
  }

  function renderCtaButton() {
    if (isCustom) {
      return (
        <Button
          variant="contained"
          color="primary"
          href={customPlanButtonHref}
          className={classes.ctaButton}
          target="_blank"
        >
          Contact Us
        </Button>
      );
    }

    if (isActive) {
      return (
        <Typography variant="h6" className={classes.currentPlan}>
          Current Plan
        </Typography>
      );
    }

    return (
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to={buildUrl()}
        className={clsx(classes.ctaButton, isActive && classes.activeCtaButton)}
      >
        {activePlanId ? 'Switch Plan' : 'Buy Now'}
      </Button>
    );
  }

  return (
    <Card className={clsx(classes.priceBox, isActive && classes.activePriceBox, className)} variant="outlined">
      <div className={classes.priceHeader}>
        <Typography variant="h6" className={classes.pricePlan}>
          {pricePlan}
        </Typography>
        {isCustom ? (
          <span role="img" className={classes.customPriceFiller}>
            😎
          </span>
        ) : (
          <Typography variant="h5" className={classes.price}>
            {price}
            <span className={classes.priceSmall}>per month</span>
          </Typography>
        )}

        {renderCtaButton()}

        <Typography
          variant="body1"
          className={clsx(classes.planDescription, isActive && classes.activePlanDescription)}
        >
          {planDescription}
        </Typography>
      </div>

      <div className={classes.divider} />

      <div className={classes.features}>
        <div>
          {features.map(feature => (
            <PricingCardFeature
              key={feature.mainText}
              mainText={feature.mainText}
              additionalText={feature.additionalText}
              isActive={isActive}
            />
          ))}
        </div>
      </div>
    </Card>
  );
}

export default withStyles(styles)(PricingCard);
